import React, { useEffect, useState } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";

const API_URL = process.env.REACT_APP_API_URL;

const GuestPaymentSuccess = () => {
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    const verifyPayment = async () => {
      try {
        const query = new URLSearchParams(location.search);
        const sessionId = query.get("session_id");

        if (!sessionId) {
          setError("❌ No session ID found in URL.");
          return;
        }

        const endpoint = `${API_URL}/api/guest-orders/verify?sessionId=${sessionId}`;
        const { data } = await axios.get(endpoint);
console.log(data);
        if (data.success) {
          setSuccessMessage("✅ Payment successful! Your order is now being processed.");
          setTimeout(() => {
    navigate("/");
  }, 3000); // 3 seconds delay
        } else {
          setError("❌ Payment verification failed. Please try again.");
          setTimeout(() => {
    navigate("/");
  }, 3000); // 3 seconds delay
        }
      } catch (err) {
        console.error("Error verifying guest payment:", err);
        setError("⚠ There was an issue verifying your payment. Please try again.");
      }
    };

    verifyPayment();
  }, [location]);

  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-r from-green-50 to-green-100 px-4">
      <div className="bg-white shadow-md rounded-xl p-6 max-w-md w-full text-center">
        {successMessage && (
          <p className="text-green-600 text-lg font-semibold">{successMessage}</p>
        )}
        {error && (
          <p className="text-red-600 text-lg font-semibold">{error}</p>
        )}
      </div>
    </div>
  );
};

export default GuestPaymentSuccess;
